import axios from 'src/utils/axios';
import { createSlice } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  franquicias: [],
  franquicia: null,
  map: []
};

const slice = createSlice({
  name: 'franquicia',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET FRANQUICIAS SUCCESS
    getFranquiciasSuccess(state, action) {
      state.isLoading = false;
      state.franquicias = action.payload;
    },

    // GET FRANQUICIA
    getFranquiciaSuccess(state, action) {
      state.franquicia = state.franquicias.find((c) => c.id === action.payload);
    },

    // DELETE FRANQUICIA SUCCESS
    deleteFranquiciaSuccess(state, action) {
      state.franquicias = state.franquicias.filter(
        (c) => c.id != action.payload
      );
    },

    //  CLEAN FRANQUICIA SUCCESS
    cleanFranquiciaSuccess(state, action) {
      state.franquicia = null;
    },

    // ADD FRANQUICIA SUCCESS
    addFranquiciaSuccess(state, action) {
      state.franquicias = [...state.franquicias, action.payload];
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  getFranquiciaSuccess,
  getFranquiciasSuccess,
  deleteFranquiciaSuccess,
  cleanFranquiciaSuccess,
  addFranquiciaSuccess
} = slice.actions;

// ----------------------------------------------------------------------

export function GetFranquicias() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axios.get('authentication/franquicias');
      dispatch(slice.actions.getFranquiciasSuccess(response.data.franquicias));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
